import * as React from 'react';

import { IApplicationContext } from '../../types/application';

export const Context = React.createContext<IApplicationContext | null>(null);
